import { dimensionToDimensionTargetField } from '../../consts'
import { AggregationDimensionValue } from '../../TicketsVolumeDetails'

export const getDimensionTarget = (aggregationDimension: AggregationDimensionValue) => {
  const targetField = dimensionToDimensionTargetField[aggregationDimension.dimension]

  if (!targetField) {
    return undefined
  }

  return {
    [dimensionToDimensionTargetField[aggregationDimension.dimension]]:
      aggregationDimension.dimensionTarget,
  }
}
